module.exports = __webpack_public_path__ + "img/2022-14.9d230b50.jpg";